globalThis.__VUE_OPTIONS_API__ = true;
globalThis.__VUE_PROD_DEVTOOLS__ = true;

import '../scss/products.scss';

// import 'swiper/swiper.scss';
// import 'swiper/modules/pagination/pagination.scss';
// import 'swiper/modules/thumbs/thumbs.scss';

import accordion from './scripts/accordion.js'
import tabs from './scripts/tabs.js'
import productGallery from './scripts/product-gallery.js'
import mobileGallery from './scripts/mobile-gallery.js'

window.addEventListener("DOMContentLoaded", function(event) {
	window.filterMode = 'products';
});

accordion();
tabs();
productGallery();
mobileGallery();